import '../sass/services-text-cards.scss';

(() => {
    const swiperScript = document.querySelector('#ofg-education-swiper-js');
    const $blocks = document.querySelectorAll('.block.services-text-cards');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $carousel = $block.querySelector('.services-text-cards__carousel');
        const $pagination = $block.querySelector('.services-text-cards__pagination');

        const initCarousel = () => {
            console.log($carousel);

            if (!$carousel) return;

            new Swiper($carousel, {
                pagination: {
                    el: $pagination,
                    type: 'bullets',
                    clickable: true
                }
            });
        };

        if (typeof Swiper !== 'undefined') {
            initCarousel();
        } else if (swiperScript) {
            swiperScript.addEventListener('load', () => {
                initCarousel();
            });
        } else {
            window.addEventListener('load', () => {
                const swiperScript = document.querySelector('#ofg-education-swiper-js');

                if (!swiperScript) return;

                initCarousel();
            });
        }
    });
})();
